import ROUTES from "../constants/routes";


const browserTabTitleOverride = (eventName = '', ticketName = '') => {
  const mainPart = document.title.split('|')[0];

  const pathname = window.location.pathname.at(-1) === '/'
    ? window.location.pathname.substring(0, window.location.pathname.length - 2)
    : window.location.pathname;

  const secondaryPart = pathname.split('/').at(-1).split('-').join(' ');

  let finalTitle = `${mainPart} | ${secondaryPart[0].toUpperCase() + secondaryPart.slice(1)}`;

  if (eventName && !ticketName) {
    finalTitle = `${mainPart} | ${eventName} | ${secondaryPart[0].toUpperCase() + secondaryPart.slice(1).split('-').join(' ')}`;
  }

  if (ticketName) {
    finalTitle = `${mainPart} | ${eventName} | ${ticketName}`;
  }

  return (document.title = document.title !== finalTitle && finalTitle);
}

export default browserTabTitleOverride;